import React, { useState } from 'react';
import { useHistory, useParams, useRouteMatch } from 'react-router';
import { useTranslation } from 'react-i18next';

import Dropdown from '@common/components/dropdown';
import { Button } from '@common/components/button';
import { TableDropdown } from '@common/components/table';

import { FileUploadForm } from '@modules/documents/forms/file-upload';
import FolderModalForm from '@modules/documents/forms/folder-modal-form';

import type { DocumentsRouteParams, Folder, Document } from '@modules/documents/types';

type DocumentsActionsProps = {
  currentFolder?: Folder;
  userId?: string;
  onUpdate: (document: Document) => void;
};

const DocumentsActions = ({ currentFolder, userId, onUpdate }: DocumentsActionsProps) => {
  const { t } = useTranslation();
  const { url } = useRouteMatch();
  const history = useHistory();
  const { folderId } = useParams<DocumentsRouteParams>();
  const isPersonalFolder = !!currentFolder?.personal_root_user_id || folderId === 'personal';
  const [createFolderModalVisible, setCreateFolderModalVisible] = useState<boolean>(false);
  const [uploadFileModalVisible, setUploadFileModalVisible] = useState<boolean>(false);

  return (
    <>
      <Dropdown
        alignRight
        toggle={(
          <Button type="primary" icon="add" size="large">
            {t('documents:new')}
          </Button>
      )}
      >
        <TableDropdown.Item icon="folder" onClick={() => setCreateFolderModalVisible(true)}>
          {t('documents:folder')}
        </TableDropdown.Item>
        <FileUploadForm
          parentFolderId={folderId}
          userId={isPersonalFolder ? userId : undefined}
          personalFolder={isPersonalFolder}
          onUpdate={onUpdate}
        >
          <TableDropdown.Item icon="upload" onClick={() => setUploadFileModalVisible(true)}>
            {t('documents:upload')}
          </TableDropdown.Item>
        </FileUploadForm>
        {!isPersonalFolder && (
        <TableDropdown.Item icon="document" onClick={() => history.push(`${url}/page/new`)}>
          {t('documents:page')}
        </TableDropdown.Item>
      )}
      </Dropdown>
      {createFolderModalVisible ? (
        <FolderModalForm
          initialIsVisible
          userId={isPersonalFolder ? userId : undefined}
          onUpdate={onUpdate}
          currentFolder={currentFolder}
          onClose={() => setCreateFolderModalVisible(false)}
        />
      ) : null}
      {uploadFileModalVisible ? (
        <FileUploadForm
          initialIsVisible
          parentFolderId={folderId}
          userId={isPersonalFolder ? userId : undefined}
          personalFolder={isPersonalFolder}
          onUpdate={onUpdate}
          closeModal={() => setUploadFileModalVisible(false)}
          isChildShow={false}
        />
      ) : null}
    </>
  );
};

export default DocumentsActions;
